import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useDispatch, useSelector } from "react-redux";
import Loader from "../loader";
import favoriteIcon from "../../assets/images/favorite_star.png";
import Table, { TableProps } from "antd/lib/table";
import { Select, Checkbox } from 'antd';
import '../../assets/css/style.css'
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import Layout from '../Layout';
import '../../../src/custom.css'
import updateIcon from "../../assets/images/updateIcon.svg"
import { Modal } from 'antd';
import { Tooltip } from 'antd';
import Trash_light from "../../assets/images/Trash_light.svg";
import { fetchAllParentQRId, fetchAllQrCodesWithThumbnail, fetchAllParentChildQRId, fetchQrCodesBySiteId, fetchAllQrCodes, updateAllParentQRId, fetchUpdatedQRCode } from '../../Redux/Api/fetch.api';
import { getQrCodeData, updateQRCodeData } from '../../Redux/Actions/QR';
import { getQrCodeThumbnail } from '../../Redux/Actions/QR';
import { setQrCodeIdData } from '../../Redux/Actions/QrCodeId';
import { updateParentByQRId } from '../../Redux/Actions/assignQR';
import LoginImage from "../../assets/images/login-image.png";
import { getQrParentChildData } from "../../Redux/Actions/QRParentChild";
import Switch from "react-switch";
import InvalidQR from '../UserLogin/InvalidQR';
import { updateInstLocationData } from '../../Redux/Actions/LocationActions';
import axios from 'axios';
import * as url from "../../api/uri_helper"
import { useTranslation } from "react-i18next";

const TOAST_LIMIT = 1;
const IndexQrAssigning = () => {
    const { t } = useTranslation("dashboard");
    const { toasts } = useToasterStore();
    useEffect(() => {
        toasts
            .filter((t) => t.visible) // Only consider visible toasts
            .filter((_, i) => i >= TOAST_LIMIT) // Is toast index over limit
            .forEach((t) => toast.dismiss(t.id)); // Dismiss – Use toast.remove(t.id) removal without animation
    }, [toasts]);
    const allQrDataWithThumbnail = useSelector((state) => state.allQrDataWithThumbnail.qrCodeThumbnailData);
    const [qrId, setQRId] = useState()
    const [parentId, setParentId] = useState()
    const [qrCodeId, setQrCodeId] = useState([{}]);
    const [loading, setLoading] = useState(false);
    const [table, setTable] = useState([]);
    const [pageSize, setPageSize] = useState(50);
    const [checkedListOfIds, setCheckedListOfIds] = useState([]);
    const [copyQRCodeId, setCopyQRCodeId] = useState();
    const [options, setOptions] = useState({
        pagination: {
            current: 1,
            pageSize: 50,
            total: 0,
            showSizeChanger: true,
            pageSizeOptions: ['50', '100']
        }
    });
    const [search, setSearch] = useState("")
    const [searchData, setSearchData] = useState()
    const [checkScannedData, setCheckScannedData] = useState()
    const [searchClicked, setSearchClicked] = useState(false)
    const [searchError, setSearchError] = useState()
    const [count, setCount] = useState(0)
    const [searchOptions, setSearchOptions] = useState({
        pagination: { current: 1 }, pageSize: pageSize
    })
    const [total, setTotal] = useState()
    const [searchtotal, setSearchTotal] = useState()
    const [pageData, setPageData] = useState({});
    const [state, setState] = useState({ message: "", items: [] })
    const [pageURL, getPageURL] = useState("");
    const dispatch = useDispatch();
    //To immediatel fetch favourite changes
    const [changeOnFav, setChangeOnFav] = useState(false)
    const [selectedItem, setSelectedItem] = useState("")
    const comingsiteId = localStorage.getItem('SiteId');
    const prevCountRef = useRef(selectedItem);
    const [showAllData, setShowAllData] = useState(false);
    const loggedUserId = localStorage.getItem('UserId')
    const [selectedParent, setSelectedParent] = useState([])
    const [isMultiple, setIsMultiple] = useState(false);
    const [checkListChildId, setCheckedListOfId] = useState([])



    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 2000)
        const nameUrl = window.location.host
        getPageURL(nameUrl)
        setLoading(false)
        getAllQRCodes(options, showAllData);
        setPageData(options)
        getAllQRWithThumbnail();
    }, [changeOnFav, selectedItem])

    useEffect(() => {
        const qrcodeIdsOnly = checkedListOfIds.map(item => item.qRcodeId);
        setCheckedListOfId(qrcodeIdsOnly);
    }, [checkedListOfIds]);

    useEffect(() => {
        if (search !== "") {
            handleSearch()
        }
    }, [table])
    const handleDataSearch = (e) => {
        setSearchError("")
        setSearch(e.target.value)
        setCount(e.target.value.length)
        if (e.target.value == "") {
            setSearchData(table)
        }
    }
    const handleSearch = () => {
        if (search == "") {
            setSearchError(t("PleaseEnterQRProduct"));
        }
        else if (search != "") {
            var searchProductName = table.length > 0 ? table.filter(item => item.product_Name != null && item.product_Name.toLowerCase().startsWith(search.toLowerCase().trim()) || item.product_Name != null && item.product_Name.toLowerCase().includes(search.toLowerCase().trim())) : ""
            var searchDataFinal = table.length > 0 ? table.filter(item => item.qRcodeId.toString().startsWith(search)) : ""
            if (searchDataFinal.length < 1) {
                setSearchClicked(true)
                setSearchData("")
            }
            if (searchDataFinal.length > 0) {
                setSearchClicked(true)
                setSearchData(searchDataFinal)
                setSearchOptions({
                    ...searchOptions,
                    pagination: {
                        pageSize: searchOptions.pageSize,
                        current: searchOptions.pagination.current,
                        total: searchDataFinal.length,
                        pageSizeOptions: ['50', '100'],
                        showSizeChanger: true,
                    }
                })
            }
            else {
                if (searchProductName.length > 0) {
                    setSearchClicked(true)
                    setSearchData(searchProductName)
                    setSearchOptions({
                        ...searchOptions,
                        pagination: {
                            pageSize: searchOptions.pagination.pageSize,
                            current: searchOptions.pagination.current,
                            searchtotal: searchProductName.count,
                            pageSizeOptions: ['50', '100'],
                            showSizeChanger: true,
                        }
                    })
                }
            }
        }
    }
    const handleResetButton = () => {
        setSearchClicked(false)
        setSearch("")
        setSearchData("")
        setSearchError("")
        getAllQRCodes(options, showAllData)
        setIsMultiple(false)
    }

    const handleFavourite = (record) => {
        fetchUpdatedQRCode(record.qRcodeId)
            .then(response => {
                toast.success(response.data.message, {
                    className: "toastSuccess",
                },);
                getAllQRCodes();
                setChangeOnFav(true)
            })
            .catch((err) => console.log("error", err))
    }

    const uncheckcheckbox = () => {
     
        var items = document.getElementsByName('checkname');
        for (var i = 0; i < items.length; i++) {
            if (items[i].type == 'checkbox')
                items[i].checked = false;
        }
        setIsMultiple(false)
    }

    const deleteParentChildData = async (childId, parentId) => {
        setLoading(true);

        try {
            const response = await axios.delete(url.DELETE_PARENT_CHILD, {
                params: {
                    childId: childId,
                    parentId: parentId
                }
            });

            toast.success(response.data.message, {
                className: "toastSuccess",
            });

            getAllQRCodes(options, showAllData);

        } catch (err) {
            console.log("Err: ", err);
        } finally {
            setLoading(false);
        }
    };


    const getAllQRCodes = (options, showAllData) => {
        const siteIdToSend = showAllData ? 0 : comingsiteId;
        setLoading(true)
        fetchQrCodesBySiteId(siteIdToSend)
            .then(response => {

                dispatch(getQrCodeData(response.data));
                setTable(response.data.data)
                setQrCodeId(response.data.data.qrCodeId)
                setParentId(response.data.data.parent_QRCodeID)
                setTotal(response.data.count)
                setOptions({
                    ...options,
                    pagination: {
                        pageSize: options.pagination.pageSize,
                        current: options.pagination.current,
                        total: response.data.count,
                        pageSizeOptions: ['50', '100'],
                        showSizeChanger: true,
                    }
                })
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
        setTimeout(() => {
            setLoading(false)
        }, 2000)
    }

    const verifyQRCodeData = (id) => {
        fetchAllParentChildQRId(id)
            .then((response) => {

                if (response.data.success) {
                    dispatch(getQrParentChildData(response.data.data));
                    setCheckScannedData(response.data.data.scanedQRDetails);
                }
            })

    }

    const getAllQRWithThumbnail = () => {

        setLoading(true)
        fetchAllQrCodesWithThumbnail()
            .then(response => {
                dispatch(getQrCodeThumbnail(response.data));
                setChangeOnFav(false)
                setLoading(false);
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }


    const handleChange = (pagination) => {
        setOptions(prev => ({
            ...prev,
            pagination: {
                ...prev.pagination,
                current: pagination.current,
                pageSize: pagination.pageSize,
            }
        }));

        getAllQRCodes({
            pagination: {
                current: pagination.current,
                pageSize: pagination.pageSize
            }
        }, true); // Pass `true` to force siteId = 0
    };

    const handleBulkChildAssign = async () => {

        setLoading(true)
        if (checkedListOfIds.length >= 1) {
            const data = [];

            if (isMultiple) {
                checkedListOfIds.forEach(childId => {
                    selectedParent.forEach(parent => {
                        data.push({
                            ChildQRcode: childId.qRcodeId,
                            Id: childId.id,
                            ParentQR: parent
                        });
                    });
                });
                console.log('data :', data);
                setSelectedParent([])
                setCopyQRCodeId();
                const response = await axios.put(url.ADD_BULKPARENTCHILDQRS,
                    {
                        BulkChildQrs: data,
                        UserId: loggedUserId
                    }).then(response => {

                        dispatch(updateInstLocationData(response.data))

                        if (!response.data.success) // False 
                        {

                            toast.error(response.data.message, {
                                className: "toastSuccess",
                            });
                        }
                        else {
                            toast.success(response.data.message, {
                                className: "toastSuccess",
                            })
                        }
                        setLoading(false)
                    })
            }
            else {

                checkedListOfIds.map(x => data.push({
                    ChildQRcode: x.qRcodeId,
                    Id: x.id,
                    ParentQR: copyQRCodeId
                }))
                console.log('data :', data);

                const response = await axios.put(url.ADD_BULKCHILDQRS,
                    {
                        "BulkChildQrs": data,
                        "UserId": loggedUserId
                    }).then(response => {

                        dispatch(updateInstLocationData(response.data))

                        if (!response.data.success) // False 
                        {

                            toast.error(response.data.message, {
                                className: "toastSuccess",
                            });
                        }
                        else {
                            toast.success(response.data.message, {
                                className: "toastSuccess",
                            })
                        }
                        setLoading(false)
                    })
            }
            setCopyQRCodeId();
            setSelectedParent([])
            getAllQRCodes(options, showAllData);
            setCheckedListOfIds([])
            uncheckcheckbox();
            setIsMultiple(false)
        }
    };



    const { confirm } = Modal;
    const handleDelete = (childId, parentId) => {
        confirm({
            title: 'Are you sure you want to delete this Parent Child Relation?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                deleteParentChildData(childId, parentId)
            },
            onCancel() {
            },
        });
    }

    const getFullDate = (date) => {

        const dateAndTime = date.split('T');
        const time = dateAndTime[1].split(':')
        const newtime = time[0] + ':' + time[1];
        const times = time[0] > 12 ? "0" + time[0] % 12 : time[0]
        const newtime1 = times + ':' + time[1]
        if (time[0] && time[0] >= 12) {
            return dateAndTime[0] == "0001-01-01" ? "" : dateAndTime[0].split('-').reverse().join('-') + ', ' + newtime1 + " PM ";
        }
        else {
            return dateAndTime[0] == "0001-01-01" ? "" : dateAndTime[0].split('-').reverse().join('-') + ', ' + newtime + " AM ";
        }
    };


    const updateParentByQR = (childQrCodeId) => {
        // get pid from state variable parentId
        const changedQrCodes = selectedQrCodePairs;
        let parentQRCodeId = changedQrCodes.find(item => item.child == childQrCodeId).parent;
        updateAllParentQRId(childQrCodeId, parentQRCodeId)
            .then(response => {
                dispatch(updateParentByQRId(response.data))
                toast.success(response.data.message, {
                    className: "toastSuccess",
                },);
                setSelectedItem("")
                prevCountRef.current = ""
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    };
    //states and function for dropdown search
    const [searchState, setSearchState] = useState()
    const handleInputForDropdown = (e) => {
        const QRProductPresent = allQrDataWithThumbnail.filter((item) => item.qRcodeId.toString().startsWith(e) || item.qRcodeId.toString().includes(e))
        QRProductPresent.length > 0 ? setSearchState("Number") : setSearchState("String")
    }
    const [selectedQrCodePairs, setSelectedQrCodePairs] = useState([]);
    const parentDdChangeHndlr = (selectedParentValue, selectedForChild, defaultValue) => {
        prevCountRef.current = defaultValue;
        let alreadyChanged = false;
        let result = selectedQrCodePairs && selectedQrCodePairs.length > 0 && [...selectedQrCodePairs].map((item) => {
            if (item.child == selectedForChild) {
                item.parent = selectedParentValue
                alreadyChanged = true;
            }
            return item
        })
        if (alreadyChanged) // if already changed once and in the state array
            setSelectedQrCodePairs(result);
        else // add new object for new change
            setSelectedQrCodePairs([...selectedQrCodePairs, { child: selectedForChild, parent: selectedParentValue }]);
        setParentId(selectedParentValue);
        setSelectedItem(selectedParentValue)
    }

    const handleSwitchChange = (checked) => {

        setShowAllData(checked);
        getAllQRCodes(options, checked);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    }

    const handleCheck = (qRcodeId, rowId) => {
        var updatedList = [...checkedListOfIds];
        if (event.target.checked) {
            updatedList = [...checkedListOfIds, { qRcodeId: qRcodeId, id: rowId }];
        } else {
            updatedList.splice(checkedListOfIds.indexOf(qRcodeId), 1);
        }
        setCheckedListOfIds([...updatedList]);

    };

    const handleOnChange = (e) => {
        isMultiple ? setSelectedParent(e) : setCopyQRCodeId(e)
    };

    const { Option } = Select;
    const columns = [

        {
            title: " ",
            dataIndex: "qRcodeId",
            hidden: false,
            render: (qRcodeId, record) => (<div className="checkgroup">
                {
                    <input type="checkbox" className="btn-checkbox" name="checkname"

                        onChange={() => { handleCheck(qRcodeId, record.id) }}
                        key={qRcodeId}
                    ></input>
                }
            </div>)
        },

        {
            title: t("ChildQR"),
            dataIndex: "qRcodeId",
            className: "qrcode_mapping",
        },
        {
            title: t("Site"),
            dataIndex: "qRcodeId",
            className: "Locations",
            key: 'index',
            render: (text, record, index) => (
                <>
                    {record.locationName}
                </>
            )
        },

        {
            title: t("ProductName"),
            dataIndex: "product_Name",
            render: (product_Name) => <Tooltip placement='topLeft' className="media-tooltip prdouct-name" title={product_Name}>{product_Name ? product_Name : "- NA -"}</Tooltip>,
        },

        {
            title: t("MfDate"),
            dataIndex: "manufacturing_Date",
            className: "update_qrcode",
            key: 'manufacturing_Date',
            render: ((date) =>
                getFullDate(date)
            )
        },

        {
            title: t("ParentQR"),
            dataIndex: "parent_QRCodeID",
            className: "qrcode_mapping",
            render: (text) => text ? text : "" // or text ?? ""
        },


        //{
        //    title: "Assigned Parent QR",
        //    dataIndex: "parent_QRCodeID",
        //    key: 'i',
        //    render: (parent_QRCodeID, row, i) => (

        //            <div className='d-flex qrTable--select qr-img-select mapping wkmapping' >
        //                <Select class="form-select mb-0 flex-grow-1 filter-select " aria-label=".form-select-lg example"
        //                showSearch
        //                style={{ width: 250 }}
        //                    placeholder="Add Parent"
        //                    onChange={(value) => {
        //                        var productFound = allQrDataWithThumbnail.filter((item) => item.product_Name==value)
        //                        if(productFound.length>0){
        //                          parentDdChangeHndlr(productFound[0].qRcodeId, row.qRcodeId,parent_QRCodeID);
        //                        }
        //                        else{
        //                          parentDdChangeHndlr(value, row.qRcodeId,parent_QRCodeID);
        //                        }
        //                    }}
        //                    id={i + 1}
        //                    key={row.qRcodeId}
        //                    defaultValue={parent_QRCodeID}
        //                    onSearch={(e) => {
        //                 handleInputForDropdown(e)
        //                            }}
        //                    >

        //                    <Option key={0} value={0}>{'Assign QR Code'} </Option>

        //                    {
        //                        allQrDataWithThumbnail && allQrDataWithThumbnail.map((qrCodes, k) => (

        //                            qrCodes.qRcodeId != row.qRcodeId ?
        //                                <Option
        //                                    key={qrCodes.qRcodeId}
        //                                     value={searchState === "Number" || qrCodes.product_Name == null ? qrCodes.qRcodeId : qrCodes.product_Name}

        //                                >
        //                                    <div className="d-flex gap20 align-items-center">
        //                                        <div className="avatar-img">
        //                                        {qrCodes.filename ?
        //                                            <>
        //                                               < img className="img-mapping" src={qrCodes.filename}></img>{qrCodes.favorites == true ? <img className="favorite_star" src={favoriteIcon}></img> : ""}
        //                                            </>
        //                                            :
        //                                            <>
        //                                                < img className="img-mapping" src={LoginImage}></img>{qrCodes.favorites == true ? <img className="favorite_star" src={favoriteIcon}></img> : ""}
        //                                            </>
        //                                            }
        //                                            </div>
        //                                        <div className="qrDesc content d-flex ">
        //                                            {qrCodes.product_Name ? <Tooltip title={qrCodes.product_Name}>
        //                                                <h6>{qrCodes.product_Name}</h6>
        //                                            </Tooltip>

        //                                             : <h6>- NA - </h6>}
        //                                            <p> {qrCodes.qRcodeId}</p>

        //                                            <Tooltip title={qrCodes.qR_Description}>
        //                                                <p>{qrCodes.qR_Description}</p>
        //                                            </Tooltip>
        //                                        </div>
        //                                    </div>
        //                                </Option>
        //                                : null
        //                        ))}
        //                </Select>
        //            </div>                                   
        //    )
        //},

        //{
        //    title: "Update",
        //    key: 'index',
        //    className: "update_mapping",
        //    render: (text, record, index) => (<>

        //        <button className="assign-btn btn " id={index + 1}>
        //            <img src={updateIcon} onClick={(e) => handleUpdate(record.qRcodeId, record.parent_QRCodeID)} ></img>
        //        </button>
        //    </>)
        //},



        {
            title: t("Favourite"),
            key: 'index',
            render: (text, record, index) => (
                <>
                    <Switch
                        onChange={() => handleFavourite(record)}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        checked={record.favorites}
                        onColor="#bb9977"
                        handleDiameter={20}
                        height={16}
                        width={35}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        onHandleColor="#b97a57"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    />
                </>
            )
        },


        {
            title: t("UserSection"),
            dataIndex: "",
            render: (record) =>

            (
                <a href={record.qRcodeId} target="_blank" className="preview_Link" onClick={(e) => verifyQRCodeData(record.qRcodeId)}>{t("Preview")}


                </a>
            )
        },

        {
            title: t("Action"),
            dataIndex: "",
            render: (data) => (
                <>
                    {data.parent_QRCodeID != null && (
                        <button className="table-btn">
                            <img
                                src={Trash_light}
                                onClick={() => handleDelete(data.qRcodeId, data.parent_QRCodeID)}
                                alt="delete"
                            />
                        </button>
                    )}
                </>
            )
        },
    ]
    return (
        <Layout title={t("QRMapping")}>
            <Toaster />
            {!searchClicked ?
                <>
                    <div className="position-relative">
                        <div className="card-box-header qrassign-header d-inline-flex justify-content-between w-100 align-items-center m-0 gap-4 flex-wrap">
                            <div className='d-inline-flex gap-3 flex-wrap'><div className='d-inline-flex align-items-center flex-wrap gap-2' >
                                <span>{t("SearchQRProduct")}</span>
                                <div className='d-inline-flex'>
                                    <div className='d-inline-flex flex-column position-relative'>
                                        <input type="text" className='form-control searchQR' value={search} placeholder={t("EnterQRProduct")}
                                            onChange={(e) => {
                                                handleDataSearch(e); setSearchError(false)
                                            }}
                                            onKeyDown={(e) => handleKeyPress(e)}
                                        ></input>
                                        {
                                            <small className="text-danger d-block qRcodeError top-100 position-absolute position-md-absolute position-sm-relative">{searchError}</small>
                                        }
                                    </div>
                                    <button onClick={() => handleSearch()} className="searchButton ml-2 mt-2 mt-sm-0">{t("Search")}</button>
                                </div>


                            </div>

                                <div className="d-flex align-items-center">
                                    <label className="filter-col me-1 mb-0">{t("ShowAllLabel")}</label>
                                    <Switch
                                        onChange={handleSwitchChange}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        checked={showAllData}
                                        onColor="#bb9977"
                                        handleDiameter={20}
                                        height={16}
                                        width={35}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        onHandleColor="#b97a57"

                                    />
                                </div>
                            </div>

                            {checkedListOfIds.length >= 1 &&
                                <div class="d-flex  gap-2 filter-box1 allign-items-center flex-wrap flex-md-nowrap">
                                    <div className="d-flex align-align-items-center gap-2">
                                        <span className='text-nowrap'>{t("AssignMultiple")} </span>
                                        <Checkbox checked={isMultiple} onChange={(e) => setIsMultiple(e.target.checked)} />
                                    </div>
                                    <span>{t("SelectParentQRLabel")} </span>
                                    <div class="d-flex select-qr-select gap-2 flex-wrap w-100">
                                        <Select
                                            className="mb-0 flex-grow-1 filter-select"
                                            aria-label=".form-select-lg     example"
                                            showSearch
                                            value={isMultiple ? selectedParent : copyQRCodeId}
                                            optionFilterProp="label"
                                            optionLabelProp="label"
                                            onChange={handleOnChange}
                                            onSearch={handleInputForDropdown}
                                            dropdownAlign={{ points: ['tr', 'br'], offset: [0, 4] }} // Align dropdown right
                                            dropdownStyle={{ minWidth: 300 }} // Minimum width for dropdown
                                            mode={`${isMultiple && 'multiple'}`}
                                        >
                                            <Option value="0">{t("SelectQRPlaceholder")}</Option>
                                            {allQrDataWithThumbnail &&
                                                allQrDataWithThumbnail
                                                    .filter(QRCode => !checkListChildId.includes(QRCode.qRcodeId))
                                                    .map((QRCode) => (
                                                        <Option
                                                            key={QRCode.qRcodeId}
                                                            value={QRCode.qRcodeId}
                                                            label={`${QRCode.qRcodeId}`}
                                                        >
                                                            <div className="d-flex gap20 align-items-center qrDrop">
                                                                <div className="avatar-img">
                                                                    <img className="img-mapping" src={QRCode.filename || LoginImage} />
                                                                </div>
                                                                <div className="qrDesc content d-flex">
                                                                    {QRCode.product_Name ? (
                                                                        <Tooltip title={QRCode.product_Name}>
                                                                            <h6>{QRCode.product_Name}</h6>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <h6>- NA -</h6>
                                                                    )}
                                                                    <p>{QRCode.qRcodeId}</p>
                                                                    <Tooltip title={QRCode.qR_Description}>
                                                                        <p>{QRCode.qR_Description}</p>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                        </Option>
                                                    )
                                                    )
                                            }
                                        </Select>

                                        {(checkedListOfIds.length >= 1 && ((!isMultiple && copyQRCodeId) || (isMultiple && selectedParent.length >= 1))) &&
                                            <button className="searchButton" onClick={handleBulkChildAssign}>{t("Assign")}</button>
                                        }
                                    </div>
                                </div>}
                        </div>
                    </div>

                    <div className="Viewer-table position-relative mb-4 pagination-sticky">
                        {loading ? <Loader /> : ''}
                        <Table
                            className='table-responsive antd--detail-table Viewer-table '
                            columns={columns}
                            dataSource={table}
                            pagination={
                                total > 50 ? options.pagination : false
                            }
                            onChange={handleChange}
                            //  paginationTotalRows={total}
                            scroll={{ x: "750px" }}
                        />
                    </div>
                </> :
                <>
                    <div className="position-relative reviewPage">
                        <div className="card-box-header qrassign-header d-inline-flex w-100 align-items-start m-0 gap-3 justify-content-between flex-wrap">
                            <div className='d-flex gap-3 flex-lg-row flex-column flex-wrap'>
                                <div className='d-flex align-items-end flex-wrap gap-3'>
                                    <div className='d-flex align-items-center flex-wrap gap-2'>
                                        <p className='m-0 text-nowrap'> {t("SearchQRProduct")}</p>
                                        <div className='d-flex flex-column gap-2 width-box position-relative '>

                                            <input type="text" className='form-control searchQR mt-0' value={search} placeholder={t("EnterQRProduct")}
                                                onChange={(e) => {
                                                    handleDataSearch(e)
                                                }}
                                                onKeyDown={(e) => handleKeyPress(e)}
                                            />
                                            < small className="text-danger d-block qRcodeError top-100 position-absolute position-md-absolute position-sm-relative">{searchError}</small>
                                        </div>
                                    </div>

                                    <div className='d-flex flex-wrap'>
                                        <button className='searchButton ml-md-2  ' onClick={() => handleSearch()} >{t("Search")}</button>
                                        {search == "" ? "" : <button className='searchButton ml-2   ' onClick={() => handleResetButton()} >{t("Reset")}</button>}
                                    </div>

                                </div>
                                <div className="d-flex align-items-center">
                                    <label className="filter-col me-1 mb-0">{t("ShowAllDataLabel")}</label>
                                    <Switch
                                        onChange={handleSwitchChange}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        checked={showAllData}
                                        onColor="#bb9977"
                                        handleDiameter={20}
                                        height={16}
                                        width={35}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        onHandleColor="#b97a57"
                                    // activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                    />
                                </div>
                            </div>

                            {checkedListOfIds.length >= 1 &&
                                <div class="d-flex  gap-2 filter-box1 allign-items-center flex-wrap flex-md-nowrap">
                                    <div className="d-flex align-align-items-center gap-2">
                                        <span className='text-nowrap'>{t("AssignMultiple")} </span>
                                        <Checkbox checked={isMultiple} onChange={(e) => setIsMultiple(e.target.checked)} />
                                    </div>
                                    <span>{t("SelectParentQRLabel")} </span>
                                    <div class="d-flex select-qr-select gap-2 flex-wrap w-100">
                                        <Select
                                            className="mb-0 flex-grow-1 filter-select"
                                            aria-label=".form-select-lg example"
                                            showSearch
                                            value={isMultiple ? selectedParent : copyQRCodeId}
                                            optionFilterProp="label"
                                            optionLabelProp="label"
                                            onChange={handleOnChange}
                                            onSearch={handleInputForDropdown}
                                            dropdownAlign={{ points: ['tr', 'br'], offset: [0, 4] }} // Align dropdown right
                                            dropdownStyle={{ minWidth: 300 }} // Minimum width for dropdown
                                            mode={`${isMultiple && 'multiple'}`}
                                        >
                                            <Option value="0">{t("SelectQRPlaceholder")}</Option>
                                            {allQrDataWithThumbnail &&
                                                allQrDataWithThumbnail
                                                    .filter(QRCode => !checkListChildId.includes(QRCode.qRcodeId))
                                                    .map((QRCode) => (
                                                        <Option
                                                            key={QRCode.qRcodeId}
                                                            value={QRCode.qRcodeId}
                                                            label={`${QRCode.qRcodeId}`}
                                                        >
                                                            <div className="d-flex gap20 align-items-center qrDrop">
                                                                <div className="avatar-img">
                                                                    <img className="img-mapping" src={QRCode.filename || LoginImage} />
                                                                </div>
                                                                <div className="qrDesc content d-flex">
                                                                    {QRCode.product_Name ? (
                                                                        <Tooltip title={QRCode.product_Name}>
                                                                            <h6>{QRCode.product_Name}</h6>
                                                                        </Tooltip>
                                                                    ) : (
                                                                            <h6>{t("NA")}</h6>
                                                                    )}
                                                                    <p>{QRCode.qRcodeId}</p>
                                                                    <Tooltip title={QRCode.qR_Description}>
                                                                        <p>{QRCode.qR_Description}</p>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                        </Option>
                                                    )
                                                    )
                                            }
                                        </Select>

                                        {(checkedListOfIds.length >= 1 && ((!isMultiple && copyQRCodeId) || (isMultiple && selectedParent.length >= 1))) &&
                                            <button className="searchButton" onClick={handleBulkChildAssign}>{t("Assign")}</button>
                                        }
                                    </div>
                                </div>}
                        </div>
                    </div>

                    <div className="Viewer-table position-relative mb-4 pagination-sticky">
                        {loading ? <Loader /> : ''}
                        <Table
                            className='table-responsive antd--detail-table Viewer-table '
                            columns={columns}
                            dataSource={searchData}
                            pagination={
                                searchtotal > 50 ? searchOptions.pagination : false
                            }
                            // pagination={searchOptions.pagination.total > 10 ? searchOptions.pagination : false}
                            onChange={handleChange}
                            // paginationTotalRows={total}
                            scroll={{ x: "750px" }}
                        />
                    </div>
                </>
            }

        </Layout >
    )
}

export default connect()(IndexQrAssigning);
